export const foods = [
  {
    id: 1,
    name: 'Begal and Cream cheese',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 23.33,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/Breakfast/breakfast1.png',
    category: 'breakfast',
  },
  {
    id: 2,
    name: 'Breakfast Sandwich',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 25.33,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/Breakfast/breakfast2.png',
    category: 'breakfast',
  },
  {
    id: 3,
    name: 'Backed Chicken',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 27.21,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/Breakfast/breakfast3.png',
    category: 'breakfast',
  },
  {
    id: 4,
    name: 'Eggs Benedict',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 30.23,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/Breakfast/breakfast4.png',
    category: 'breakfast',
  },
  {
    id: 5,
    name: 'Toast Croissant fired Egg',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 32.45,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/Breakfast/breakfast5.png',
    category: 'breakfast',
  },
  {
    id: 6,
    name: 'Full Breakfast fired Egg Toast Brunch',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 43.0,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/Breakfast/breakfast6.png',
    category: 'breakfast',
  },

  {
    id: 7,
    name: 'Begal and Cream cheese',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 23.33,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/lunch/lunch1.png',
    category: 'lunch',
  },
  {
    id: 8,
    name: 'Breakfast Sandwich',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 25.33,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/lunch/lunch2.png',
    category: 'lunch',
  },
  {
    id: 9,
    name: 'Backed Chicken',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 27.21,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/lunch/lunch3.png',
    category: 'lunch',
  },
  {
    id: 10,
    name: 'Eggs Benedict',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 30.23,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/lunch/lunch4.png',
    category: 'lunch',
  },
  {
    id: 11,
    name: 'Toast Croissant fired Egg',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 32.45,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/lunch/lunch5.png',
    category: 'lunch',
  },
  {
    id: 12,
    name: 'Full Breakfast fired Egg Toast Brunch',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 43.0,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/lunch/lunch6.png',
    category: 'lunch',
  },
  {
    id: 13,
    name: 'Begal and Cream cheese',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 23.33,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/Dinner/dinner1.png',
    category: 'dinner',
  },
  {
    id: 14,
    name: 'Breakfast Sandwich',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 25.33,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/Dinner/dinner2.png',
    category: 'dinner',
  },
  {
    id: 15,
    name: 'Backed Chicken',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 27.21,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/Dinner/dinner3.png',
    category: 'dinner',
  },
  {
    id: 16,
    name: 'Eggs Benedict',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 30.23,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/Dinner/dinner4.png',
    category: 'dinner',
  },
  {
    id: 17,
    name: 'Toast Croissant fired Egg',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 32.45,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/Dinner/dinner5.png',
    category: 'dinner',
  },
  {
    id: 18,
    name: 'Full Breakfast fired Egg Toast Brunch',
    description:
      'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptas provident optio quidem',
    price: 43.0,
    image:
      'https://res.cloudinary.com/dqv2g1wux/image/upload/v1600062233/Foods/Dinner/dinner6.png',
    category: 'dinner',
  },
];
